// extracted by mini-css-extract-plugin
export default {"comprasucedida1":"CompraEfetuada_comprasucedida1__ogxIF"};